import { INSURANCE_PROVIDERS } from '~/app/modules/insurance/utils/insurance.const';
import { DocumentLinksConfig } from '~/utils/documentsConfig';

export const insurancePolicies = {
  [INSURANCE_PROVIDERS.DORDOI](locale) {
    return DocumentLinksConfig.insurancePolicyDordoi[locale];
  },
  [INSURANCE_PROVIDERS.A_PLUS](locale) {
    return DocumentLinksConfig.insurancePolicy[locale];
  },
};

export const insuranceAgreements = {
  [INSURANCE_PROVIDERS.DORDOI](locale) {
    return DocumentLinksConfig.insuranceAgreementDordoi[locale];
  },

  [INSURANCE_PROVIDERS.A_PLUS](locale) {
    return DocumentLinksConfig.insuranceAgreement[locale];
  },
};

insuranceAgreements.undefined = insuranceAgreements[INSURANCE_PROVIDERS.A_PLUS];
insurancePolicies.undefined = insurancePolicies[INSURANCE_PROVIDERS.A_PLUS];

export function getInsurancePolicy(provider, locale) {
  return insurancePolicies[provider](locale);
}

export function getInsuranceAgreement(provider, locale) {
  return insuranceAgreements[provider](locale);
}

export default function insuranceAgreementsPlugin({ app }, inject) {
  function getInsuranceAgreementArgs() {
    return [app.$client.application.insuranceProvider, app.i18n.locale];
  }

  inject('insuranceAgreements', {
    get agreement() {
      return getInsuranceAgreement(...getInsuranceAgreementArgs());
    },
    get policy() {
      return getInsurancePolicy(...getInsuranceAgreementArgs());
    },
  });
}
